/**
 * @copyright Microsoft Corporation. All rights reserved.
 *
 * @file Analytics ActionBar component
 */

import * as React from 'react';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { AnalyticsStats, IAnalyticsStatsProps } from '../hoverCardStats/AnalyticsStats';
import { Shimmer, ShimmerElementType } from '@uifabric/experiments/lib/Shimmer';
import * as AnalyticsActionBarStyle from './AnalyticsActionBar.scss';

export interface IAnalyticsActionBarProps {
  items: IContextualMenuItem[];
  farItems: IContextualMenuItem[];
  analyticsStats: IAnalyticsStatsProps;
  showActionBar?: boolean;
  withFacePile?: boolean;
}

const SHIMMER_WIDTH_FACEPILE = 35;
const SHIMMER_WIDTH_NO_FACEPILE = 50;
const SHIMMER_LINE_HEIGHT = 8;

export const AnalyticsActionBar: React.StatelessComponent<IAnalyticsActionBarProps> = (props: IAnalyticsActionBarProps) => {

  const { items, farItems, analyticsStats, withFacePile, showActionBar = true } = props;
  const isDataLoaded: boolean = analyticsStats &&
    (analyticsStats.viewCount || analyticsStats.isNotSupported) ?
      true :
      false;
  return (
    <div>
      <div className={ `${AnalyticsActionBarStyle.msAnalyticsActionBarStats}` }>
          <Shimmer
            width={ withFacePile ? SHIMMER_WIDTH_FACEPILE : SHIMMER_WIDTH_NO_FACEPILE }
            isDataLoaded={ isDataLoaded }
            lineElements={ [
              { type: ShimmerElementType.LINE, height: SHIMMER_LINE_HEIGHT }
            ] }
          >
            <AnalyticsStats
              withFacePile={ withFacePile }
              isCompact={ true }
              { ...analyticsStats }
            />
          </Shimmer>
      </div>
      {
        showActionBar &&
        <CommandBar
          className={ `${AnalyticsActionBarStyle.msAnalyticsActionBarBar}` }
          items={ items }
          farItems={ farItems }
        />
      }
    </div >
  );
};